import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_STAFF_CREATE_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_STAFF_CREATE_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_STAFF_CREATE_API_ID,
  ({ payload }) => ({
    endpoint: `/api/admin/staffs`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);

export default apiCall;
